module.exports = "https://static.wmbcdn.com/uniweb/images/e3480525a68b799a4be9af561d16f81e.svg";